import { render, staticRenderFns } from "./ProgramManager.vue?vue&type=template&id=56c81572"
import script from "./ProgramManager.vue?vue&type=script&lang=js"
export * from "./ProgramManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports